import { Reducer } from 'react';
import { BrowsePageOutput } from 'js/model/rainbow/browse-page/BrowsePageOutput';
import { ChannelOutput } from 'js/model/rainbow/content/ChannelOutput';
import { enrichBrowsePageOutputWithLocationIfMissing } from './utils';

type State = { browsePageOutput: BrowsePageOutput; isLoading: boolean };

type Action =
  | { type: 'SEARCH_START' }
  | {
      type: 'SEARCH_SUCCESS';
      payload: BrowsePageOutput;
    }
  | { type: 'SEARCH_FAILURE' };

export const createInitialState = ({
  browsePageOutput,
  channelLocation,
}: {
  browsePageOutput: BrowsePageOutput;
  channelLocation: ChannelOutput['country'];
}): State => ({
  browsePageOutput: {
    ...enrichBrowsePageOutputWithLocationIfMissing(
      browsePageOutput,
      channelLocation
    ),
  },
  isLoading: false,
});

export const reducer: Reducer<State, Action> = (state, action) => {
  switch (action.type) {
    case 'SEARCH_START': {
      return { ...state, isLoading: true };
    }
    case 'SEARCH_SUCCESS': {
      return {
        browsePageOutput: action.payload,
        isLoading: false,
      };
    }
    case 'SEARCH_FAILURE': {
      return { ...state, isLoading: false };
    }
    default: {
      return state;
    }
  }
};
